import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlightPathTop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1184,
	height: 172,
	viewBox: "0 0 1184 172",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.241943 17.3631C91.3067 67.7411 327.199 160.975 578.033 155.175M1183.24 0.433685C1109.48 42.7573 894.857 132.483 626.46 152.799C622.552 153.095 618.646 153.364 614.742 153.609",
		stroke: "#176BEB",
		strokeDasharray: "10 10"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M593.131 166.568L598.785 157.041L605.313 156.821C608.111 156.726 610.395 155.249 610.814 153.834C610.301 152.451 607.922 151.131 605.124 151.225L598.596 151.446L592.313 142.321C591.921 141.774 591.356 141.607 590.802 141.812L590.063 142.024C589.419 142.326 589.065 142.898 589.18 143.547L591.136 151.697L586.505 152.787L583.612 150.084L581.747 150.147L582.837 154.778L582.062 159.472L583.927 159.409L586.63 156.517L591.325 157.293L589.923 165.556C589.852 166.212 590.244 166.759 590.906 167.016L591.568 167.274C592.224 167.345 592.777 167.14 593.131 166.568Z",
		stroke: "#176BEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFlightPathTop;
